import type { BulkImportDateFormat } from "@gettactic/api";
import { useMutation } from "@tanstack/react-query";
import { useTacticHooks } from "../../providers/TacticHooksProvider";
import { useInvalidateBulkImports } from "../invalidate/useInvalidateBulkImports";
import { uploadFileToS3 } from "./uploadFileToS3";

type Args = {
  file: File;
  officeId: string;
  visitorTypeId: string;
  dateFormat?: BulkImportDateFormat;
  onUploadProgress?: (progress: number) => void;
};

export const useCreateVisitorPreregistrationImportMutation = () => {
  const { apiClient } = useTacticHooks();
  const invalidateBulkImports = useInvalidateBulkImports();

  return useMutation({
    mutationFn: async ({
      file,
      officeId,
      visitorTypeId,
      dateFormat,
      onUploadProgress
    }: Args) => {
      const uploadRes = await apiClient.bulkImports.createUpload(
        "visitor_preregistration"
      );
      if (!uploadRes.ok || !uploadRes.result) {
        throw uploadRes;
      }
      const { upload_url, s3_path } = uploadRes.result;

      await uploadFileToS3(upload_url, file, "text/csv", onUploadProgress);

      const importRes =
        await apiClient.bulkImports.createVisitorPreregistrationImport({
          s3_path,
          office_id: officeId,
          visitor_type_id: visitorTypeId,
          date_format: dateFormat
        });
      if (!importRes.ok || !importRes.result) {
        throw importRes;
      }
      return importRes.result;
    },
    onSuccess: async () => {
      await invalidateBulkImports();
    }
  });
};
